export default __webpack_public_path__ + "static/media/hotel-out-2.e98ae128.jpg";